import React from 'react';
import { RecoilState, useRecoilState } from 'recoil';
import {
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup
} from '@mui/material';
import { CustomTypography } from 'shared/ui/CustomTypography';

interface Props {
  directionState: RecoilState<string>;
  label: string;
}

const radioSx = {
  color: '#e9e9e9',
  '&.Mui-checked': {
    color: '#1976d2',
  },
  transform: 'scale(.9)',
  padding: '4px',
};

export const DirectionForm: React.FC<Props> = ({
  directionState,
  label,
}) => {
  const [direction, setDirection] = useRecoilState(directionState);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDirection((event.target as HTMLInputElement).value);
  };

  return (
    <Box component="div" sx={{ paddingTop: 1 }}>
      <Grid container alignItems="center" spacing={0.5}>
        <Grid item xs={5}>
          <CustomTypography>
            {label}
          </CustomTypography>
        </Grid>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="dmorphing-direction-label"
            name="row-radio-buttons-group"
            value={direction}
            onChange={handleChange}
          >
            <FormControlLabel
              value="x"
              control={<Radio sx={radioSx} />}
              label={<CustomTypography>X</CustomTypography>}
            />
            <FormControlLabel
              value="y"
              control={<Radio sx={radioSx} />}
              label={<CustomTypography>Y</CustomTypography>}
            />
            <FormControlLabel
              value="z"
              control={<Radio sx={radioSx} />}
              label={<CustomTypography>Z</CustomTypography>}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Box>
  );
};
